import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.object,
  correctAnswerText: PropTypes.string,
};

export const CorrectAnswersGraphic = ({ children, correctAnswerText }) => {
  return (
    <svg
      width="194"
      height="128"
      viewBox="0 0 194 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{correctAnswerText}</title>
      <path
        d="M182.023 56.7477C188.656 56.7477 194.034 51.4679 194.034 44.9549C194.034 38.4419 188.656 33.1621 182.023 33.1621C175.389 33.1621 170.012 38.4419 170.012 44.9549C170.012 51.4679 175.389 56.7477 182.023 56.7477Z"
        fill="#CCE1FF"
      />
      <path
        d="M155.271 56.7482C163.8 56.7482 170.714 49.9599 170.714 41.586C170.714 33.2122 163.8 26.4238 155.271 26.4238C146.742 26.4238 139.828 33.2122 139.828 41.586C139.828 49.9599 146.742 56.7482 155.271 56.7482Z"
        fill="#CCE1FF"
      />
      <path
        d="M170.288 41.5856C176.922 41.5856 182.299 36.3058 182.299 29.7928C182.299 23.2798 176.922 18 170.288 18C163.655 18 158.277 23.2798 158.277 29.7928C158.277 36.3058 163.655 41.5856 170.288 41.5856Z"
        fill="#CCE1FF"
      />
      <path d="M182.303 37.373H146.27V56.7469H182.303V37.373Z" fill="#CCE1FF" />
      <path
        d="M13.2715 39.5872C6.49421 39.5872 1.00011 34.1929 1.00011 27.5387C1.00011 20.8845 6.49421 15.4902 13.2715 15.4902C20.0489 15.4902 25.543 20.8845 25.543 27.5387C25.543 34.1929 20.0489 39.5872 13.2715 39.5872Z"
        fill="#CCE1FF"
      />
      <path
        d="M50.0858 39.5892C41.3721 39.5892 34.3083 32.6537 34.3083 24.0983C34.3083 15.5429 41.3721 8.60742 50.0858 8.60742C58.7995 8.60742 65.8633 15.5429 65.8633 24.0983C65.8633 32.6537 58.7995 39.5892 50.0858 39.5892Z"
        fill="#CCE1FF"
      />
      <path
        d="M29.045 24.0969C22.2676 24.0969 16.7735 18.7027 16.7735 12.0485C16.7735 5.39429 22.2676 0 29.045 0C35.8223 0 41.3164 5.39429 41.3164 12.0485C41.3164 18.7027 35.8223 24.0969 29.045 24.0969Z"
        fill="#CCE1FF"
      />
      <path d="M13.2677 19.793H50.082V39.5868H13.2677V19.793Z" fill="#CCE1FF" />
      <path
        d="M91.8217 2.36472C94.9507 -0.78824 100.049 -0.78824 103.178 2.36472L105.626 4.83158C107.868 7.08997 111.234 7.80547 114.2 6.65397L117.44 5.39614C121.581 3.78846 126.239 5.86225 127.815 10.0154L129.048 13.2647C130.177 16.2394 132.961 18.2624 136.139 18.4168L139.611 18.5854C144.047 18.801 147.459 22.59 147.21 27.0251L147.015 30.4951C146.836 33.6718 148.557 36.6524 151.397 38.086L154.5 39.652C158.465 41.6536 160.041 46.5027 158.009 50.4529L156.42 53.5435C154.964 56.3729 155.324 59.7957 157.336 62.2608L159.533 64.9533C162.342 68.3948 161.809 73.4655 158.346 76.2478L155.637 78.4247C153.157 80.4176 152.093 83.6908 152.928 86.7609L153.841 90.1145C155.007 94.4008 152.457 98.816 148.162 99.95L144.802 100.836C141.726 101.648 139.423 104.206 138.937 107.35L138.406 110.785C137.728 115.175 133.603 118.172 129.218 117.46L125.788 116.904C122.647 116.394 119.503 117.794 117.78 120.469L115.899 123.391C113.494 127.125 108.506 128.185 104.79 125.752L101.883 123.848C99.2207 122.105 95.7787 122.105 93.1167 123.848L90.2097 125.752C86.4933 128.185 81.5062 127.125 79.1011 123.391L77.2193 120.469C75.4966 117.794 72.3524 116.394 69.2118 116.904L65.7812 117.46C61.3965 118.172 57.2718 115.175 56.5936 110.785L56.063 107.35C55.5772 104.206 53.2743 101.648 50.1978 100.836L46.8373 99.95C42.5423 98.816 39.9931 94.4008 41.1591 90.1145L42.0714 86.7609C42.9066 83.6908 41.8429 80.4176 39.3627 78.4247L36.6535 76.2478C33.1908 73.4655 32.6577 68.3948 35.4663 64.9533L37.6638 62.2608C39.6755 59.7957 40.0352 56.3729 38.58 53.5435L36.9904 50.4529C34.9587 46.5027 36.5342 41.6536 40.4998 39.652L43.6024 38.086C46.4428 36.6524 48.1637 33.6718 47.9851 30.4951L47.79 27.0251C47.5406 22.59 50.9522 18.801 55.3891 18.5854L58.8605 18.4168C62.0385 18.2624 64.8229 16.2394 65.9518 13.2647L67.1848 10.0154C68.7609 5.86225 73.4187 3.78846 77.5597 5.39614L80.7995 6.65397C83.7655 7.80547 87.132 7.08997 89.3732 4.83158L91.8217 2.36472Z"
        fill="#0052C4"
      />
      <path
        d="M98 113C125.062 113 147 91.062 147 64C147 36.938 125.062 15 98 15C70.938 15 49 36.938 49 64C49 91.062 70.938 113 98 113Z"
        fill="#106FF3"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M19.8141 78.253C15.662 78.253 12.2961 74.9482 12.2961 70.8716C12.2961 66.795 15.662 63.4902 19.8141 63.4902C23.9661 63.4902 27.332 66.795 27.332 70.8716C27.332 74.9482 23.9661 78.253 19.8141 78.253Z"
        fill="#CCE1FF"
      />
      <path
        d="M42.3653 78.2541C37.0269 78.2541 32.6993 74.0051 32.6993 68.7638C32.6993 63.5224 37.0269 59.2734 42.3653 59.2734C47.7036 59.2734 52.0312 63.5224 52.0312 68.7638C52.0312 74.0051 47.7036 78.2541 42.3653 78.2541Z"
        fill="#CCE1FF"
      />
      <path
        d="M29.4781 68.7628C25.3261 68.7628 21.9601 65.458 21.9601 61.3814C21.9601 57.3048 25.3261 54 29.4781 54C33.6302 54 36.9961 57.3048 36.9961 61.3814C36.9961 65.458 33.6302 68.7628 29.4781 68.7628Z"
        fill="#CCE1FF"
      />
      <path
        d="M19.8133 66.127H42.3672V78.2535H19.8133V66.127Z"
        fill="#CCE1FF"
      />
      <path
        d="M8 48C8 48 11.5 46.5 12 46C12.5 45.5 14 42 14 42C14 42 15.5 45.5 16 46C16.5 46.5 20 48 20 48C20 48 16.5 50.1667 16 50.6667C15.5 51.1667 14 54 14 54C14 54 12.5 51.1667 12 50.6667C11.5 50.1667 8 48 8 48Z"
        fill="#04337A"
        stroke="#04337A"
        strokeLinejoin="round"
      />
      <path
        d="M4 37.5C4 37.5 6.04167 36.625 6.33333 36.3333C6.625 36.0417 7.5 34 7.5 34C7.5 34 8.375 36.0417 8.66667 36.3333C8.95833 36.625 11 37.5 11 37.5C11 37.5 8.95833 38.7639 8.66667 39.0556C8.375 39.3472 7.5 41 7.5 41C7.5 41 6.625 39.3472 6.33333 39.0556C6.04167 38.7639 4 37.5 4 37.5Z"
        fill="#106FF3"
        stroke="#106FF3"
        strokeLinejoin="round"
      />
      <path
        d="M166 76C166 76 169.5 74.5 170 74C170.5 73.5 172 70 172 70C172 70 173.5 73.5 174 74C174.5 74.5 178 76 178 76C178 76 174.5 78.1667 174 78.6667C173.5 79.1667 172 82 172 82C172 82 170.5 79.1667 170 78.6667C169.5 78.1667 166 76 166 76Z"
        fill="#106FF3"
        stroke="#106FF3"
        strokeLinejoin="round"
      />
      <path
        d="M176 64.5C176 64.5 178.042 63.625 178.333 63.3333C178.625 63.0417 179.5 61 179.5 61C179.5 61 180.375 63.0417 180.667 63.3333C180.958 63.625 183 64.5 183 64.5C183 64.5 180.958 65.7639 180.667 66.0556C180.375 66.3472 179.5 68 179.5 68C179.5 68 178.625 66.3472 178.333 66.0556C178.042 65.7639 176 64.5 176 64.5Z"
        stroke="#04337A"
        strokeLinejoin="round"
      />
      <path
        d="M166 54.5C166 54.5 168.042 53.625 168.333 53.3333C168.625 53.0417 169.5 51 169.5 51C169.5 51 170.375 53.0417 170.667 53.3333C170.958 53.625 173 54.5 173 54.5C173 54.5 170.958 55.7639 170.667 56.0556C170.375 56.3472 169.5 58 169.5 58C169.5 58 168.625 56.3472 168.333 56.0556C168.042 55.7639 166 54.5 166 54.5Z"
        fill="#04337A"
        stroke="#04337A"
        strokeLinejoin="round"
      />
      <path
        d="M47 7.5C47 7.5 49.0417 6.625 49.3333 6.33333C49.625 6.04167 50.5 4 50.5 4C50.5 4 51.375 6.04167 51.6667 6.33333C51.9583 6.625 54 7.5 54 7.5C54 7.5 51.9583 8.76389 51.6667 9.05556C51.375 9.34722 50.5 11 50.5 11C50.5 11 49.625 9.34722 49.3333 9.05556C49.0417 8.76389 47 7.5 47 7.5Z"
        stroke="#106FF3"
        strokeLinejoin="round"
      />
      {children}
    </svg>
  );
};

CorrectAnswersGraphic.propTypes = propTypes;
